exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".messageInput__container___1RBEo .messageInput__textArea___B_NYC {\n  height: 98px;\n  background-color: #f7f7f7;\n  border: none;\n  font-size: 16px;\n  color: #3f3f3f;\n  padding-left: 15px; }\n", ""]);

// exports
exports.locals = {
	"container": "messageInput__container___1RBEo",
	"textArea": "messageInput__textArea___B_NYC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/EmailDealerForm/MessageInput/messageInput.scss
// module id = 4521
// module chunks = 6